module.exports = __webpack_public_path__ + "static/media/upload.45753f15.png";